import type { Locale } from '@/i18n';
import { LEARN, type LearnMeta } from './index';
import { LEARN_TEXT_HI } from './index.hi';

/** The Learn list in the parent's language: Hindi titles and summaries over the English entries. */
export const learnFor = (locale: Locale): LearnMeta[] =>
  locale === 'hi' ? LEARN.map((a) => ({ ...a, ...LEARN_TEXT_HI[a.slug] })) : LEARN;

export const learnMetaFor = (slug: string, locale: Locale): LearnMeta | undefined => learnFor(locale).find((a) => a.slug === slug);
